import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Zap } from 'lucide-react';
export function Mechanism() {
  return <Section bg="sage" data-id="element-100">
      <div className="max-w-4xl mx-auto text-center" data-id="element-101">
        <div className="inline-flex items-center justify-center p-4 bg-sage-600 rounded-full mb-8" data-id="element-102">
          <BookOpen className="w-10 h-10 text-sage-100" data-id="element-103" />
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-8 text-white" data-id="element-104">
          Presentamos la Guía Inteligente de Suplementos.
        </h2>

        <div className="bg-sage-800/50 p-8 md:p-10 rounded-2xl border border-sage-600 backdrop-blur-sm text-left" data-id="element-105">
          <p className="text-xl text-sage-50 leading-relaxed mb-6" data-id="element-106">
            Esta no es una enciclopedia médica aburrida. Es un sistema de
            consulta rápida diseñado para que en menos de 5 minutos sepas
            exactamente cómo organizar tu rutina diaria.
          </p>
          <div className="flex items-start gap-4 bg-sage-900/50 p-6 rounded-xl border border-sage-700" data-id="element-107">
            <Zap className="w-8 h-8 text-terracotta flex-shrink-0 mt-1" data-id="element-108" />
            <p className="text-lg text-white font-medium" data-id="element-109">
              Hemos destilado años de conocimiento en{' '}
              <span className="text-terracotta font-bold" data-id="element-110">
                Tablas de Aplicación Inmediata
              </span>{' '}
              que eliminan cualquier margen de error.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}